const path = require( 'path' );

const ROOT_PATH = path.resolve( __dirname );
const APP_PATH = path.resolve( ROOT_PATH, 'src/app' );
const BUILD_PATH = path.resolve( ROOT_PATH, 'build' );
const INDEX_FILE_TEMPLATE_PATH = path.resolve( ROOT_PATH, 'src/index.html' );
const PUBLIC_PATH = path.resolve( ROOT_PATH, 'public' );
const API_PATH = path.resolve( PUBLIC_PATH, 'api' );

const NS = 'engage';

module.exports = {
    ROOT_PATH: ROOT_PATH,
    APP_PATH: APP_PATH,
    BUILD_PATH: BUILD_PATH,
    INDEX_FILE_TEMPLATE_PATH: INDEX_FILE_TEMPLATE_PATH,
    PUBLIC_PATH: PUBLIC_PATH,
    API_PATH: API_PATH,
    NS: NS
};
